/**
 * NOTE: These variables are also declared in variables.scss. Both files should be kept in sync.
 */
const Styles = {
    zIndexWidgetContents: 1000,
    // Note: this matches the value of overlay-buttons-z-idx in LifeAtApp.scss
    zIndexTopNavigation: 4000,
    zIndexModal: 6000,

    widgetBorderRadius: "7px",

    borderRadiusNormal: "10px",
    borderRadiusSharp: "5px",
    borderRadiusExtraSharp: "2px",

    widgetToolbarWidth: "55px",

    distanceFromSidesOfWindow: "8px",

    topBarHeight: "40px",
    topBarAndPaddingHeight: "48px",
    overlayButtonHeight: "36px",
    sideNavigationWidth: "70px",
    bottomNavigationHeight: "70px",

    sidebarWidth: "340px",

    lifeatSpecialRed: "#E39685",
    lifeatSpecialPurple: "#9497F8",
    lifeatSpecialBlue: "#B9D1FF",

    buttonFillRed: "#E39685",
    buttonFillBlue: "royalblue",
    buttonFillGreen: "#6BC0BB",

    userAviColors: {
        blue: "#BADEFF",
        pink: "#FFE0D7",
        yellow: "#FFF4BA",
        purple: "#CACCFF",
        grey: "#E7E7E7",
        green: "#C7FFD6",
    },
};

export default Styles;
